import { TypedRootState } from '../types';

export const selectCRangeForLoadedGeometry = (state: TypedRootState) => state.cRangeForLoadedGeometry;
